/* VIP LED swatches — картинка до бутона за опция "Осветление".
   Не пипа логиката за варианти: рисува плочки над съществуващия <select>
   (vip-pdp-hero.liquid), а при клик сменя стойността му и пуска "change".
   Конфигурация: window.VIP_LED_SWATCHES = { sid, images: { none, '3000k', '4500k', '6000k' } } */
(function () {
  var cfg = window.VIP_LED_SWATCHES;
  if (!cfg || !cfg.images) return;

  var selects = document.querySelectorAll('[data-vip-sid="' + cfg.sid + '"][data-vip-option]');

  // Ключ на картинката по текста на стойността: 3000K / 4500K / 6000K / без LED
  function swatchKey(value) {
    var v = value.toLowerCase();
    var k = v.match(/(\d{4})\s*k/);
    if (k) return k[1] + 'k';
    if (v.indexOf('без') !== -1 && (v.indexOf('led') !== -1 || v.indexOf('лед') !== -1)) return 'none';
    return null;
  }

  // Само ВИДИМИЯТ текст. Стойността на варианта (напр. "с LED 4500K") не се променя —
  // тя се изпраща с поръчката и се ползва от системата за производство.
  var VISIBLE_LABELS = {
    'none': 'Без LED',
    '3000k': 'Топла светлина',
    '4500k': 'Дневна светлина',
    '6000k': 'Студена светлина'
  };
  function shortLabel(value, key) {
    return (key && VISIBLE_LABELS[key]) || value;
  }

  // Един ред описание под плочките за избраната светлина
  var VISIBLE_DESCRIPTIONS = {
    'none': 'Само огледало, без вградено осветление.',
    '3000k': 'Топлата светлина носи уют през тъмната част от ежедневието.',
    '4500k': 'Дневната светлина е универсална, подходяща за през деня.',
    '6000k': 'Студената светлина е най-бяла и подходяща за грим, бръснене, прецизна работа.'
  };
  var DESC_ICON = '✨'; // може да се смени с 👉

  // Цвят на светлината върху стената (r,g,b). 3000K — кехлибар, 4500K — почти бяла с лека топлина,
  // 6000K — студенобяла (без синьо). "Без LED" няма светлина.
  var LIGHT_RGB = {
    '3000k': '255,168,40',
    '4500k': '255,232,178',
    '6000k': '190,220,255'
  };

  selects.forEach(function (sel) {
    var group = sel.closest('.vip-hero-option-group');
    var labelEl = group && group.querySelector('.vip-hero-option-label');
    if (!labelEl || labelEl.textContent.trim().toLowerCase() !== 'осветление') return;

    var wrap = document.createElement('div');
    wrap.className = 'vip-led-swatches';
    wrap.setAttribute('role', 'radiogroup');
    wrap.setAttribute('aria-label', labelEl.textContent.trim());

    var glow = document.createElement('div');
    glow.className = 'vip-led-glow';
    glow.setAttribute('aria-hidden', 'true');
    var shade = document.createElement('div');
    shade.className = 'vip-led-shade';
    shade.setAttribute('aria-hidden', 'true');
    wrap.appendChild(shade);
    wrap.appendChild(glow);

    var radios = [];
    Array.prototype.forEach.call(sel.options, function (opt, i) {
      var key = swatchKey(opt.value);
      var src = key && cfg.images[key];

      var label = document.createElement('label');
      label.className = 'vip-led-swatch';
      label.title = shortLabel(opt.value, key);
      label.setAttribute('data-led', key || 'other');

      var input = document.createElement('input');
      input.type = 'radio';
      input.className = 'vip-led-swatch__input';
      input.name = 'vip-led-swatch-' + cfg.sid;
      // form="" към несъществуващ id — да не се изпраща с формата на продукта
      input.setAttribute('form', 'vip-led-swatch-noform');
      input.value = opt.value;
      input.checked = opt.selected;
      input.setAttribute('data-key', key || '');
      input.addEventListener('change', function () {
        if (!input.checked) return;
        sel.value = opt.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      radios.push(input);

      var box = document.createElement('span');
      box.className = 'vip-led-swatch__img' + (src ? '' : ' is-empty');
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.width = 64;
        img.height = 64;
        img.loading = 'lazy';
        box.appendChild(img);
      }

      var text = document.createElement('span');
      text.className = 'vip-led-swatch__label';
      // Двусловните имена (Топла светлина) — всяка дума в свой <span>, за да са на два реда на десктоп
      var shown = shortLabel(opt.value, key);
      var parts = shown.split(' ');
      if (key && parts.length === 2) {
        parts.forEach(function (word, n) {
          if (n) text.appendChild(document.createTextNode(' '));
          var s = document.createElement('span');
          s.textContent = word;
          text.appendChild(s);
        });
      } else {
        text.textContent = shown;
      }

      label.appendChild(input);
      label.appendChild(box);
      label.appendChild(text);
      wrap.appendChild(label);
    });

    var desc = document.createElement('p');
    desc.className = 'vip-led-desc';
    desc.setAttribute('aria-live', 'polite');

    function updateDesc() {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      var text = (checked && VISIBLE_DESCRIPTIONS[checked.getAttribute('data-key')]) || '';
      desc.textContent = '';
      if (text) {
        var icon = document.createElement('span');
        icon.className = 'vip-led-desc__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = DESC_ICON;
        desc.appendChild(icon);
        desc.appendChild(document.createTextNode(text));
      }
      desc.hidden = !text;
    }

    // Позиционира светлината върху стената зад избраната плочка (с кратко избледняване при смяна)
    var glowTimer;
    function placeGlow(animate) {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      var rgb = checked && LIGHT_RGB[checked.getAttribute('data-key')];
      clearTimeout(glowTimer);
      if (!rgb) { glow.style.opacity = 0; shade.style.opacity = 0; return; }
      function apply() {
        var box = checked.nextElementSibling;
        if (!box || !box.offsetWidth) box = checked.parentNode;
        var w = wrap.getBoundingClientRect();
        var b = box.getBoundingClientRect();
        var cx = b.left - w.left + b.width / 2;
        var cy = b.top - w.top + b.height / 2;
        glow.style.setProperty('--c', rgb);
        glow.style.left = (cx - glow.offsetWidth / 2) + 'px';
        glow.style.top = (cy - glow.offsetHeight / 2) + 'px';
        glow.style.opacity = 1;
        shade.style.left = (cx - shade.offsetWidth / 2) + 'px';
        shade.style.top = (cy - shade.offsetHeight / 2) + 'px';
        shade.style.opacity = 1;
      }
      if (animate) {
        glow.style.opacity = 0;
        glowTimer = setTimeout(apply, 140);
      } else {
        apply();
      }
    }

    // Ако друг код смени стойността на <select> — държим плочките синхронизирани
    sel.addEventListener('change', function () {
      radios.forEach(function (r) { r.checked = (r.value === sel.value); });
      updateDesc();
      placeGlow(true);
    });

    sel.setAttribute('data-vip-has-cards', 'true');
    sel.parentNode.insertBefore(wrap, sel.nextSibling);
    wrap.appendChild(desc); // описанието е част от "стената"
    updateDesc();
    placeGlow(false);
    window.addEventListener('load', function () { placeGlow(false); });
    window.addEventListener('resize', function () { placeGlow(false); });
  });
})();
